import { AbstractControl, ValidationErrors } from '@angular/forms';

export function pixCpfValidator(control: AbstractControl): ValidationErrors | null {
  const value = String(control.value || '').replace(/\D/g, '');

  if (!value) {
    return null;
  }

  if (value.length !== 11 && value.length !== 14) {
    return { documentIncomplete: true };
  }

  if (/^(\d)\1+$/.test(value)) {
    return { documentInvalid: true };
  }

  if (value.length === 11) {
    return isValidCpf(value) ? null : { documentInvalid: true };
  }

  return isValidCnpj(value) ? null : { documentInvalid: true };
}

function isValidCpf(value: string): boolean {
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number(value[i]) * (10 - i);
  }

  let firstCheck = (sum * 10) % 11;
  if (firstCheck === 10) {
    firstCheck = 0;
  }

  if (firstCheck !== Number(value[9])) {
    return false;
  }

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += Number(value[i]) * (11 - i);
  }

  let secondCheck = (sum * 10) % 11;
  if (secondCheck === 10) {
    secondCheck = 0;
  }

  return secondCheck === Number(value[10]);
}

function isValidCnpj(value: string): boolean {
  const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const firstCheck = calculateCnpjDigit(value.substring(0, 12), firstWeights);
  if (firstCheck !== Number(value[12])) {
    return false;
  }

  const secondCheck = calculateCnpjDigit(value.substring(0, 13), secondWeights);
  return secondCheck === Number(value[13]);
}

function calculateCnpjDigit(value: string, weights: number[]): number {
  let sum = 0;
  for (let i = 0; i < value.length; i++) {
    sum += Number(value[i]) * weights[i];
  }

  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}
